(function () {
  'use strict';
  angular.module('vcdms.vcscan')
    .component('filebrowser', {
      restrict: 'E',
      bindings: {
        filemode: '@',
        clientid: '<?',
        clientmode: '@?'
      },
      template: `
        <h3  ng-show="vm.files.length === 0">
            <span ng-show="vm.filemode === 'scan'">Dokumente zuordnen</span>
            <span ng-show="vm.filemode === 'signoff'">Dokumente vidieren</span>
        </h3>
        <div class="alert alert-info" ng-show="vm.files.length === 0">

            <h4><i class="fa fa-info-circle"></i> Es sind derzeit keine Dokumente zu bearbeiten.</h4>
        </div>
        <div ng-show="vm.files.length > 0">
          <h3>
            <div class="pull-left">
  
              <button class="btn btn-primary" data-hook="first_scan" ng-click="vm.firstFile()"  ng-disabled="vm.disableNavigation || vm.selectedfile === 1" uib-tooltip="Erste Datei"><i class="fa fa-step-backward"></i></button>
              <button class="btn btn-primary"  data-hook="last_scan"  ng-click="vm.previousFile()"  ng-disabled="vm.disableNavigation || vm.selectedfile === 1" uib-tooltip="Vorherige Datei"><i class="fa fa-arrow-left"></i></button>
               <span ng-show="vm.filemode === 'scan'">Dokumente zuordnen: </span>
              <span ng-show="vm.filemode === 'signoff'">Dokumente vidieren: </span>
              Datei <span data-hook="selected_scan">{{vm.selectedfile}}</span> von {{vm.files.length}}
            </div>
            <div class="pull-right">
              <button class="btn btn-primary" data-hook="next_scan" ng-click="vm.nextFile()" ng-disabled="vm.disableNavigation || vm.selectedfile === vm.files.length" uib-tooltip="Nächste Datei"><i class="fa fa-arrow-right"></i></button>
              <button class="btn btn-primary" data-hook="last_scan" ng-click="vm.lastFile()" ng-disabled="vm.disableNavigation || vm.selectedfile === vm.files.length" uib-tooltip="Letzte Datei"><i class="fa fa-step-forward"></i></button>
            </div>
          </h3>
          <div class="clearfix"></div>
          <scansorter ng-if="vm.ready === true"
                      file="vm.files[vm.selectedfileindex]" 
                      parentsave="vm.childsave(file, finish)" 
                      parentrendered="vm.childrendered(file, success)" 
                      clientmode="vm.clientmode"
                      filemode="{{vm.filemode}}" 
                      saving="vm.saving"
                      saved="vm.saved"
                      saveerror="vm.saveerror"
                      ng-show="vm.filemode === 'scan' || vm.filemode === 'signoff' "></scansorter>
          </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$window', '$timeout',
        function ($log, File, Rlog, vertxEventBusService, $window, $timeout) {
          let vm = this;
          vm.childsave = childsave;
          vm.childrendered = fileRendered;
          vm.firstFile = firstFile;
          vm.lastFile = lastFile;
          vm.nextFile = nextFile;
          vm.previousFile = previousFile;

          vm.ready = false;

          vm.$onInit = function () {
            $log.debug('[DMS][SCAN][FileBrowser] run getFiles $onInit');
            vm.disableNavigation = true;
            vm.saved = false;
            vm.saveerror = false;
            vm.saving = false;
            getFiles();
          };

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue)) {
                vm.clientid = changes.clientid.currentValue;
                $log.debug('[DMS][SCAN][FileBrowser]  run getFiles $onChange');
                getFiles();
              }
            }
          };

          function getFiles() {
            $log.debug('[DMS][SCAN][FileBrowser]  Get files called');
            if (angular.isDefined(vm.filemode)) {
              let modeerror = false;
              let query = {};
              switch (vm.filemode) {
                case 'scan':
                  query = {active: true, scanstatus: 'captured'};
                  break;
                case 'signoff':
                  query = {active: true, scanstatus: 'assigned'};
                  break;
                case 'findings':
                  query = {active: true, findingsstatus: 'captured'};
                  break;
                case 'findingsignoff':
                  query = {active: true, findingsstatus: 'assigned'};
                  break;
                default:
                  modeerror = true;
              }

              if (angular.isDefined(vm.clientid)) {
                if (vm.clientmode === 'patient') {
                  query.patientid = vm.clientid;
                } else {
                  query.clientid = vm.clientid;
                }
              }

              if (!modeerror) {
                File.$search(query).$then(function (files) {
                  $log.debug('[DMS][SCAN][FileBrowser]  Loaded files mode: ', vm.filemode, files);
                  Rlog.debug('dms.scan', 'filebrowser', 'loaded files', {
                    mode: vm.filemode,
                    numberOfFiles: files.length
                  });
                  vm.files = files;
                  vm.ready = true;
                  vm.selectedfile = 1;
                  vm.selectedfileindex = 0;
                }, function (err) {
                  $log.error('[DMS][SCAN][FileBrowser]  file loading error', err);
                  Rlog.error('dms.scan', 'filebrowser', 'file loading error', {});
                  vm.files = [];
                });
              } else {
                vm.files = [];
              }
            }
          }

          function firstFile() {
            vm.selectedfile = 1;
            vm.selectedfileindex = 0;
            vm.disableNavigation = true;
            vm.saved = false;
            vm.saveerror = false;
            vm.saving = false;
          }

          function lastFile() {
            vm.selectedfile = vm.files.length;
            vm.selectedfileindex = vm.files.length - 1;
            vm.disableNavigation = true;
            vm.saved = false;
            vm.saveerror = false;
            vm.saving = false;
          }

          function nextFile() {
            if (vm.selectedfile < vm.files.length) {
              vm.selectedfile++;
              vm.selectedfileindex++;
              vm.disableNavigation = true;
              vm.saved = false;
              vm.saveerror = false;
              vm.saving = false;
            }
          }

          function previousFile() {
            if (vm.selectedfile > 0) {
              vm.selectedfile--;
              vm.selectedfileindex--;
              vm.disableNavigation = true;
              vm.saved = false;
              vm.saveerror = false;
              vm.saving = false;
            }
          }

          function fileRendered(file, success) {
            $log.debug('[DMS][SCAN][FileBrowser]  file rendered received: ', file._id, success);
            vm.saved = false;
            vm.saveerror = false;
            vm.saving = false;
            vm.disableNavigation = false;
          }

          function childsave(file, finish) {
            vm.saved = false;
            vm.saving = false;
            vm.saveerror = false;
            if (finish) {
              vm.saving = finish;
            }
            $log.debug('[DMS][SCAN][FileBrowser] save called for file._id, fileid, finish: ', file._id, file.fileid, finish);

            if (file.$hasPendingActions()) {
              $log.warn('[DMS][SCAN][FileBrowser] file save had pending actions, cancelling now.');
              file.$cancel();
              $timeout(function (file, finish) {
                $log.warn('[DMS][SCAN][FileBrowser] waited 1.5 seconds because of file having had pending actions, saving now.');
                reallysave(file, finish, true);
              }, 1500);
            } else {
              reallysave(file, finish, false);
            }
          }

          function reallysave(file, finish, aftercancel) {
            $log.debug('[DMS][SCAN][FileBrowser] reallysave called  aftercancel for file._id, fileid, finish: ', aftercancel, file._id, file.fileid, finish);
            // TODO: error from automated test:  file undefined!!! WTF
            file.$save().$then(function () {
              $log.debug('[DMS][SCAN][FileBrowser] file saved successfully: ', file._id);
              if (finish) {
                vm.saving = false;
                vm.saved = true;

                // reposition file pointer
                $log.debug('[DMS][SCAN][FileBrowser] finishing selected file index: ', vm.selectedfile, vm.selectedfileindex, vm.files.length, file);
                while (vm.selectedfile >= vm.files.length) {
                  vm.selectedfile--;
                  vm.selectedfileindex--;
                  vm.disableNavigation = true;
                }

                $log.debug('[DMS][SCAN][FileBrowser] publish scanfile.update message for: ', file._id);

                vertxEventBusService.publish('scanfile.update', {origin: 'filebrowser'}, {timeout: 2000})
                  .then(function (reply) {
                    $log.debug('[DMS][SCAN][FileBrowser] eb reply received: ', reply);
                  })
                  .catch(function () {
                    $log.warn('[DMS][SCAN][FileBrowser] no eb reply received within 2 seconds');
                  });
              }
            }, function (errmodel) {
              $log.error('[DMS][SCAN][FileBrowser] misplaced  error branch file save failed: ', file._id, errmodel);

              if (errmodel.$response.status !== 200) {
                if (finish) {
                  vm.saving = false;
                  vm.saveerror = true;
                }
                $log.error('[DMS][SCAN][FileBrowser] file save failed: ', file._id, errmodel.$response.headers.status, errmodel);
                Rlog.error('vcdms.vcscan', 'filebrowser', 'Saving of file failed: ', {fileid: file._id});
              }

            });
          }

          const scanfileUpdateHandler = function (message) {
            $log.debug('[DMS][SCAN][FileBrowser] vertx eb scanfile.update, refresh files: ', message);
            if (angular.isDefined(vm.files)) {
              vm.files.$refresh().$then((files) => {
                $log.debug('[DMS][SCAN][FileBrowser] Files refresh for scanfile.update successfull: ', files);
                Rlog.debug('dms.scan', 'filebrowser', 'Files refresh for scanfile.update success', {});

              }, (err) => {
                $log.error('[DMS][SCAN][FileBrowser] Files refresh for scanfile.update failed: ', err);
                // Rlog.error('dms.scan', 'filebrowser', 'Files refresh for scanfile.update failed', {error: err});
                Rlog.error('dms.scan', 'filebrowser', 'Files refresh for scanfile.update failed', {});
              });
            }
          };


          const filesUpdateHandler = function (message) {
            $log.debug('[DMS][SCAN][FileBrowser] eb files.update caught: ', message);
            let fileid = message.split(':')[0];
            let tabid = message.split(':')[1];
            if (angular.isDefined(vm.files)) {

              // check if the updated file is inside the set
              if (vm.files.some(f => f._id === fileid)) {
                // and change was not caused by us
                if (tabid !== $window.sessionStorage.getItem('sprtabid')) {
                  $log.debug('[DMS][SCAN][FileBrowser] eb files.update refreshed because change did not originate in this viewer: ', message);
                  vm.files.$refresh();
                }
              }
            }
          };

          // listen for files updates
          vertxEventBusService.on('files.update', {}, filesUpdateHandler);

          // listen for scan files updates
          vertxEventBusService.on('scanfile.update', {}, scanfileUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
            vertxEventBusService.unregisterHandler('scanfile.update', {}, scanfileUpdateHandler);
          };

        }] // controller
    }); // component

// klammerfriedhof
}());